export const QRConfActionTypes = {
  API_RESPONSE_SUCCESS: '@@qr-conf/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@qr-conf/API_RESPONSE_ERROR',

  UPDATE_QR_CONF: '@@qr-conf/UPDATE_QR_CONF',
  GENERATE_QR: '@@qr-conf/GENERATE_QR',

  RESET: '@@qr-conf/RESET'
}
